import { Component } from '@angular/core';
import { IMSproductResponse } from '../../../models/product.model';
import { UserService } from 'src/app/shared/services/user-service';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { BaseUserModel } from 'src/app/Models/userModel';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProductService } from '../../../services/product-api.service';

@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './product-detail.component.html',
  styleUrl: './product-detail.component.css',
})
export class ProductDetailComponent {
  userDetails: BaseUserModel = new BaseUserModel();
  productRequest: IMSproductResponse = new IMSproductResponse();

  constructor(
    private userService: UserService,
    private productService: ProductService,
    private errorHandler: ErrorHandlerService
  ) {}

  ngOnInit() {
    let userObj = this.userService.getUserFromLocalStorage();
    if (userObj) this.userDetails = userObj;
  }

  getProduct(IMSproductRequest: IMSproductResponse) {
    this.productRequest = IMSproductRequest;
    this.getProductImages(this.productRequest.id);
  }
  getProductImages(productId: number) {
    this.productService.getProductImages(productId).subscribe({
      next: (response) => {
        this.productRequest.productImages = response;
      },
      error: (error) => {
        this.errorHandler.handleError(error);
      },
    });
  }
}
